var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingApp)?_c('v-layout',{attrs:{"align-content-center":"","justify-center":"","fill-height":"","wrap":""}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"blue-grey","indeterminate":""}})],1):_c('v-app',[_c('select-header'),_c('v-main',[_c('app')],1),_c('select-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }